
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getHrefLangs } from 'src/core/utils/href-langs';
import PageBuilder, { PageProps } from 'src/components/page-builder/index';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  data: PageProps & {
    state: 'draft' | 'published'
  },
  slug: string
};

/**
 * `Pages` page.
 */

const Pages = (props: Props): ReactElement => (
  <PageBuilder
    {...props}
    hrefLangs={getHrefLangs(props?.data?.translations, 'landingPage')}
    routeName={'landingPage'}
  />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, params, query }) {
  const slug = params?.slug;
  const hasPreview = query?.preview;
  const pageData = await fetchPage({
    hasPreview,
    locale,
    slug
  });

  if (!pageData || pageData?.state === 'draft' && hasPreview === 'false') {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `Pages` page.
 */

export default Pages;
